import { useState } from "react";
import useClickOutside from "../../../../useClickOutside";
import moment from "moment";
import { formatNumberWithCommas } from "../abstruct-component/FunctionRemoveCommas";
import { useSelectorCustom } from "../abstruct-component/useSelectorCustom";

export const ColumnStatements = (
  translate,
  warning,
  langLocal,
  handleEdit,
  goToExpenses,
  openAddExpenses,
  detailsOfStatement
) => {
  const [options, setOptions] = useState(false);
  const { currency } = useSelectorCustom();
  const [row_id, setRowId] = useState(null);
  let domNode = useClickOutside(() => {
    setOptions(false);
    setRowId(null);
  });
  const columns = [
    {
      name: <span className="color_spann">{translate("id")}</span>,
      sortable: true,
      width: "5%",
      cell: (row) => <span>{row["id"]}</span>,
    },
    {
      name: (
        <span className="color_spann">{translate("statement_number")}</span>
      ),
      sortable: true,
      width: "180px",
      cell: (row) => <span>{row?.number}</span>,
    },
    {
      name: <span className="color_spann">{translate("statement_date")}</span>,
      cell: (row) => (
        <span>{moment(row["statement_date"]).format("YYYY-MM-DD")}</span>
      ),
    },
    {
      name: <span className="color_spann">{translate("account_name")}</span>,
      sortable: true,
      cell: (row) => <span>{row?.account?.name}</span>,
    },
    {
      name: <span className="color_spann">{translate("expenses_amount")}</span>,
      sortable: true,
      cell: (row) => (
        <span>
          {formatNumberWithCommas(
            row?.expenses?.reduce((sum, expense) => sum + expense.amount, 0) ||
              0
          )}{" "}
          {translate(currency)}
        </span>
      ),
    },
    {
      name: <span className="color_spann">{translate("project_name")}</span>,
      cell: (row) => <span>{row?.project?.name}</span>,
    },
    {
      name: <span className="color_spann">{translate("actions")}</span>,
      cell: (row, index) => (
        <div>
          <i
            className="fa fa-ellipsis-v icon_edit"
            onClick={() => {
              setOptions(!options);
              setRowId(index);
            }}
          ></i>
          {options && index === row_id && (
            <div
              ref={domNode}
              className="div-actions shadow_main"
              style={langLocal === "ar" ? { left: "20px" } : { left: "-100px" }}
            >
              <span onClick={() => detailsOfStatement(row?.id)}>
                {translate("details")}
              </span>
              <span onClick={(e) => handleEdit(e, row)}>
                {translate("edit")}
              </span>
              <span onClick={(e) => goToExpenses(e, row?.id)}>
                {translate("expenses")}
              </span>
              <span onClick={(e) => openAddExpenses(e, row?.id)}>
                {translate("add_expenses")}
              </span>
            </div>
          )}
        </div>
      ),
    },
  ];
  return {
    columns,
  };
};
